// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","203":"f4d8d3e0b8adfef3d833","243":"307c1cf31df043fbcfea","395":"b22d329be1c2e4712305","556":"96aa03a8c796daafef41","720":"e986df59120b9443ada3","852":"d1906f1bbf5326e58f81"}[chunkId] + ".bundle.js";
};